// extracted by mini-css-extract-plugin
export default {"clear_button":"styled_clear_button__j-AzJ"};